import {Component} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ContentService} from '../../_services/content.service';
import {ThemeService} from '../../_services/theme.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {Community} from '../../_types/communities';
import {User, UserWithModerationInfo} from '../../_types/user';
import {AuthService} from '../../_services/auth.service';
import {map, Observable, switchMap, take} from 'rxjs';
import {CommunitiesService} from '../../_services/communities.service';
import {VerificationService} from '../../_services/verification.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SnackbarService} from '../../_services/snackbar.service';

@Component({
    selector: 'app-email-verified',
    templateUrl: './email-verified.component.html',
    styleUrl: './email-verified.component.scss'
})
export class EmailVerifiedComponent {
    community: Community | null = null;
    user!: User;
    loading: boolean = false;
    verificationCode!: string;

    constructor(public dialog: MatDialog,
                private contentService: ContentService,
                private communitiesService: CommunitiesService,
                private authService: AuthService,
                private verificationService: VerificationService,
                private snackbarService: SnackbarService,
                private route: ActivatedRoute,
                private router: Router,
                protected themeService: ThemeService,
    ) {
        this.contentService.getCurrentDashboardCommunity()
            .pipe(
                takeUntilDestroyed()
            )
            .subscribe(community => {
                this.community = community;
                this.user = this.authService.getUser();
            });
        this.route.paramMap.pipe(takeUntilDestroyed()).subscribe(res => {
            if (res.get('token')) {
                sessionStorage.setItem('emailVerificationSended', JSON.stringify(true));
                this.verificationCode = res.get('token')!;
                // Link is now has superfluous params
                if (this.verificationCode.includes('&')) {
                    this.verificationCode = this.verificationCode.split('&')[0]
                }
                this.verify();
            }
        })
    }

    get userName(): string {
        const fName: string = this.user?.first_name || '';
        const lName: string = this.user?.last_name || '';
        const fullName: string = `${fName} ${lName}`.trim();
        return fullName || this.user?.username;
    }

    get email(): string {
        return this.user?.email;
    }

    get emailVerificationSended(): boolean {
        return JSON.parse(sessionStorage.getItem('emailVerificationSended') || 'false');
    }

    sendEmail(): void {
        this.loading = true;
        this.communitiesService.getUserInformationForCommunity(this.community!.id).pipe(
            switchMap((res) => {
                return this.verificationService.sendVerificationEmail(res!.id);
            }),
            take(1)
        ).subscribe({
            next: (): void => {
                this.snackbarService.openSuccessSnackBar('Email with the code has been successfully sent to your email.');
                sessionStorage.setItem('emailVerificationSended', JSON.stringify(true));
                this.loading = false;
            },
            error: (): boolean => this.loading = false
        });
    }

    verify(): void {
        this.loading = true;
        this.verificationService.verifyEmail(this.verificationCode).pipe(
            switchMap((): Observable<UserWithModerationInfo | null> => {
                return this.communitiesService.getUserInformationForCommunity(this.community!.id).pipe(
                    map((res): UserWithModerationInfo | null => {
                        this.communitiesService.emailVerified = !res ? true : (res?.email_verified === null || !!res?.email_verified);
                        this.communitiesService.profileRefreshed = !res ? true : (res?.profile_refreshed === null || !!res?.profile_refreshed);
                        if (!this.communitiesService.emailVerified) {
                            this.router.navigate(['/verify']).then();
                            return res;
                        }
                        if (!this.communitiesService.profileRefreshed && this.community?.questions?.length) {
                            this.router.navigate(['/profile-questions']).then();
                            return res;
                        }
                        this.snackbarService.openSuccessSnackBar('Email verified successfully');
                        this.router.navigate(['/']).then();
                        sessionStorage.removeItem('emailVerificationSended');
                        return res;
                    })
                )
            }),
            take(1)
        ).subscribe({
            next: (): void => {
                this.loading = false;
            },
            error: (err): void => {
                this.snackbarService.openErrorSnackBar(err);
                this.loading = false;
            }
        });
    }
}
